import {FunctionComponent, PropsWithChildren, useEffect, useState} from "react";
import AppTitleContext from "./AppTitleContext";
import useAppTitle from "../hooks/useAppTitle";
import useGlobalState from "./GlobalState";
import BreadCrumb from "../components/shared/BreadCrumb/BreadCrumb";

const AppTitleState: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const appTitleHook = useAppTitle("Emprendedores");
    const [showAppTitle, setShowAppTitle] = useState(false);
    const { isLogged } = useGlobalState();

    useEffect(() => {
        const pathName = window.location.pathname;
        if (pathName.includes('admin') && isLogged){
            setShowAppTitle(true);
        } else {
            setShowAppTitle(false);
        }
    }, [isLogged]);

    return (
        <AppTitleContext.Provider value={appTitleHook}>
            {
                showAppTitle ? (
                    <header className="app-title flex justify-start w-[100%] p-2 pl-5">
                        <BreadCrumb pages={appTitleHook.title}/>
                    </header>
                ) : (
                    <></>
                )
            }
            {children}
        </AppTitleContext.Provider>
    );
}

export default AppTitleState;